<template>
    <div>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar.show"

    >
      {{ snackbar.text }}
      <v-btn id="arksinekbar" flat color="pink" @click.native="snackbar.show = false">Close</v-btn>
    </v-snackbar>

    </div>
</template>


<script>
  export default {
    props: ['value'],

    computed: {
      snackbar: {
        get: function () {
           return this.value;
        },
        set: function (newValue) {
            this.$emit('input', newValue )
        },
      },
    },


    data () {
      return {
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,

      }
    }
  }
</script>